import * as React from "react";
import { useMemo } from "react";
import { useFormikContext } from "formik";
import usePluginEntities from "hooks/usePluginEntities";
const validationMessageRenderer = (validationErrors) => (fieldName, defaultText) => validationErrors[fieldName] ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, defaultText), "\xA0", /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, validationErrors[fieldName]))) : /* @__PURE__ */ React.createElement("span", null, defaultText);
const AdapterConfigFormFields = React.forwardRef(({ validationErrors }, configRef) => {
  const {
    values: { config },
    setFieldValue
  } = useFormikContext();
  const adapterPlugins = usePluginEntities("lookupTableAdapters");
  const plugin = adapterPlugins.find((p) => p.type === (config == null ? void 0 : config.type));
  const validationState = (fieldName) => validationErrors[fieldName] ? "error" : null;
  const updateConfig = (newConfig) => setFieldValue("config", newConfig);
  const handleFormEvent = (event) => {
    const { name, value, type: typeFromTarget, checked } = event.target;
    const updatedValue = typeFromTarget === "checkbox" ? checked : value;
    setFieldValue(`config.${name}`, updatedValue);
  };
  const ConfigForm = useMemo(() => plugin == null ? void 0 : plugin.formComponent, [plugin]);
  if (!plugin) return null;
  return /* @__PURE__ */ React.createElement(
    ConfigForm,
    {
      config,
      ref: configRef,
      validationMessage: validationMessageRenderer(validationErrors),
      validationState,
      updateConfig,
      handleFormEvent,
      setFieldValue
    }
  );
});
export default AdapterConfigFormFields;
